import { atom } from "recoil";

export const globalLoadingState = atom({
  default: false,
  key: "globalLoadingState",
});
